import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { environment } from '../../../environments/environment';
import { NgIf } from '@angular/common';
import { LoginModalComponent } from '../../features/auth/components/login-modal/login-modal.component';
import { SessionService } from '../../core/services/session.service';

@Component({
  selector: 'app-main-body',
  templateUrl: './main-body.component.html',
  styleUrls: ['./main-body.component.scss'],
  standalone: true,
  imports: [
    RouterOutlet,
    NgIf,
    LoginModalComponent
  ]
})
export class MainBodyComponent implements OnInit {
  public sessionService = inject(SessionService);
  private readonly router = inject(Router);

  maintenanceModeOn = environment.maintenanceMode;


  ngOnInit() { }
}
